<template>
    <div>

        <!-- Start Services Area -->
		<section class="services-area-two ptb-80 mt-5">
			<div class="container">
				<div class="section-title">
					<h2>Our Services</h2>
					<div class="bar"></div>
					<p>Working with us you can lift the web reputation of your company higher than ever. We can offer you all the advantages of modern digital marketing services in Bangladesh. </p>
				</div>

				<div class="row">
					<div class="col-lg-4 col-md-6 col-sm-6">
						<router-link to="/service-details/Web-Development">
							<div class="single-services-box">
								<div class="icon">
									<feather type="chrome"></feather>
								</div>

								<h3><router-link to="/service-details/Web-Development">Website Design And Development</router-link></h3>
								<p>Successful business requires a website and we design it using latest UI's.</p>
							</div>
						</router-link>
					</div>

					<div class="col-lg-4 col-md-6 col-sm-6">
						<router-link to="/service-details/Softwer-Development">
							<div class="single-services-box">
								<div class="icon">
									<feather type="code"></feather>
								</div>

								<h3><router-link to="/service-details/Softwer-Development">Software Development</router-link></h3>
								<p>We develop softwares according to oir client requirements with the help of modern technology.</p>
							</div>
						</router-link>
					</div>

					<div class="col-lg-4 col-md-6 col-sm-6">
						<router-link to="/service-details/Search-Engine-Optimisation">
							<div class="single-services-box">
								<div class="icon">
									<feather type="search"></feather>
								</div>

								<h3><router-link to="/service-details/Search-Engine-Optimisation">Search Engine Optimisation</router-link></h3>
								<p>SEO is the most important thing for growing a business and our team of experts will help you to get the best results in it.</p>
							</div>
						</router-link>
					</div>

					<div class="col-lg-4 col-md-6 col-sm-6">
						<router-link to="/service-details/Mobile-App-Development">
							<div class="single-services-box">
								<div class="icon bg-c679e3">
									<feather type="tablet"></feather>
								</div>

								<h3><router-link to="/service-details/Mobile-App-Development">Mobile App Development</router-link></h3>
								<p>Growing businesses requires a mobile app with a website, we develop apps according to your preference and requirements.</p>
							</div>
						</router-link>
					</div>

					<div class="col-lg-4 col-md-6 col-sm-6">
						<router-link to="/service-details/IT-Consultancy">
							<div class="single-services-box">
								<div class="icon bg-c679e3">
									<feather type="tag"></feather>
								</div>

								<h3><router-link to="/service-details/IT-Consultancy">IT-Consultancy</router-link></h3>
								<p>Proper planning and guidance us required for a successful online presence.we will provide you with proper guidance.</p>
							</div>
						</router-link>
					</div>

					<div class="col-lg-4 col-md-6 col-sm-6">
						<router-link to="/service-details/E-Commerce">
							<div class="single-services-box">
								<div class="icon bg-c679e3">
									<feather type="shopping-bag"></feather>
								</div>

								<h3><router-link to="/service-details/E-Commerce">E-Commerce Development</router-link></h3>
								<p>We also provides the facility to devolop e commerce websites so that the customers can find better products at one place.</p>
							</div>
						</router-link>
					</div>

					<div class="col-lg-4 col-md-6 col-sm-6">
						<router-link to="/service-details/Digital-Marketing">
							<div class="single-services-box">
								<div class="icon bg-eb6b3d">
									<feather type="trending-up"></feather>
								</div>

								<h3><router-link to="/service-details/Digital-Marketing">Digital-Marketing and Advertising</router-link></h3>
								<p>For growing a business advertisements are required, we bring the best advertisement solutions on all of the digital platforms.</p>
							</div>
						</router-link>
					</div>
					
					<div class="col-lg-4 col-md-6 col-sm-6">
						<router-link to="/service-details/UiUxDesign">
							<div class="single-services-box">
								<div class="icon bg-eb6b3d">
									<feather type="bell"></feather>
								</div>

								<h3><router-link to="/service-details/UiUxDesign">UI and UX Design</router-link></h3>
								<p>A well thought UI I will give your brand perfect recognition on the global platform so that you reach the audience.</p>
							</div>
						</router-link>
					</div>
					
					<div class="col-lg-4 col-md-6 col-sm-6">
						<router-link to="/service-details/DomainHosting">
							<div class="single-services-box">
								<div class="icon bg-eb6b3d">
									<feather type="cloud"></feather>
								</div>

								<h3><router-link to="/service-details/DomainHosting">Domain & Hosting</router-link></h3>
								<p>We here at WB tech provide one of the best web hosting and domain solutions with all the features you need very affordable price.</p>
							</div>
						</router-link>
					</div>
				</div>
			</div>
		</section>
		<!-- End Services Area -->
    </div>
</template>

<script>
export default {
    name: 'ServicesOne'
}
</script>